export default __webpack_public_path__ + "static/media/thumbnail.ef260c5a.png";